import useSound from "use-sound";

export const useNotificationSound = () => {
  const [play] = useSound("/sounds/notify.wav", {
    volume: 1,
    preload: true,
  });

  return play;
};
